export const formatDate = (dateString) => {
  const date = new Date(dateString);
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const day = date.getDate();
  const month = months[date.getMonth()];
  const year = date.getFullYear();

  return `${day} ${month} ${year}`;
};

export const formatDateToMonthDDYYYYTimeFormat = (dateString) => {
  if (!dateString) return "-";

  const normalizedDate = dateString.includes(".")
    ? dateString.replace(/\.\d+/, (match) => match.substring(0, 4)) +
      (dateString.endsWith("Z") ? "" : "Z")
    : dateString + (dateString.endsWith("Z") ? "" : "Z");

  const date = new Date(normalizedDate);

  if (isNaN(date.getTime())) return "-";

  return date.toLocaleString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    timeZone: "Asia/Kolkata",
  });
};

export const formatDateDDMMYYTime = (dateString) => {
  if (!dateString) return "";

  const normalizedDate = dateString.includes(".")
    ? dateString.replace(/\.\d+/, "") // Remove milliseconds if present
    : dateString;

  const date = new Date(normalizedDate);

  if (isNaN(date.getTime())) return "";

  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear().toString().slice(-2);

  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");

  return `${day}/${month}/${year}, ${hours}:${minutes}`;
};
